<template>
  <div>
    <div ref="quillEditor"></div>
    <div class="form-invalid-feedback" v-if="hasError()">
      {{getError()}}
    </div>
    <div v-if="!hasError() && note" class="form-field-note">{{note}}</div>
  </div>
</template>

<style>
@import '~quill/dist/quill.snow.css';
div.ql-snow {
  background-color: #ffffff;
}
.ql-toolbar.ql-snow,
.ql-container.ql-snow {
  border: 1px solid #e5e6e7;
}
</style>

<script>
import _ from 'lodash'
import Quill from 'quill'
import formField from '@/mixins/formField'

export default {
  name: 'FormTextEditor',
  mixins: [formField],
  props: {
    config: {
      type: Object,
      default: () => { return {} }
    },
    value: [String, Number],
    note: String,
  },
  watch: {
    value: function(newVal, oldVal) {
      if (this.editor) {
        if (newVal && newVal !== this.dataValue) {
          this.dataValue = newVal
          this.editor.pasteHTML(newVal)
        } else if(!newVal) {
          this.editor.setText('')
        }
      }
    }
  },
  data() {
    return {
      editor: {},
      dataValue: {},
      defaultConfig: {
        modules: {
          toolbar: [
            ['bold', 'italic', 'underline'],
            //[{ size: [ 'small', false, 'large', 'huge' ]}],   // If enabling this, we need to support the classes in frontend + PDF reporting
            //['clean']
          ],
        },
        theme: 'snow',
      },
    }
  },
  mounted() {
    var configOptions = _.cloneDeep(this.config)
    _.defaultsDeep(configOptions, this.defaultConfig)

    this.editor = new Quill(this.$refs.quillEditor, configOptions)

    if (this.value) {
      this.editor.pasteHTML(this.value)
    }

    this.editor.on('text-change', (delta, source) => {
      
      let html = this.$refs.quillEditor.children[0].innerHTML
      const text = this.editor.getText()
      if (html === '<p><br></p>')
        html = ''
      this.dataValue = html
      
      this.$emit('input', this.dataValue)
    })
  },

  beforeDestroy() {
    this.editor.off('text-change')
  },

  methods: {
    hasError() {
      return this.getFieldError(this.$props.field).length > 0
    },
    getError() {
      return this.getFieldError(this.$props.field)
    }
  }
  
  
}
</script>